<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <h3> Tax Declaration </h3>
                        </div>
                        
                    </div>
                    <form [formGroup]="taxregimForm">
                        <div class="card-header p-3 row justify-content-between" style="background-color: #fff;">
                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-2 mb-2">
                                <div class="input mb-0 no-min-width">
                                  <div class="input-item">
                                    <input
                                      list="taskOwnerDatalist"
                                      formControlName="userId"
                                      
                                      value=""
                                    />
                                    <datalist id="taskOwnerDatalist">
                                      <option
                                        [value]="item"
                                        *ngFor="let item of userDropdownList"
                                      ></option>
                                    </datalist>
                                     <label class="floating-label floating-label-special">Employee Name</label> 
                                    <i class="ri-user-line"></i>
                                  </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-2 mb-2">
                                <div class="input mb-0 no-min-width">
                                    <div class="input-item">
                                        <select formControlName="year">
                                            <!-- <option value="" disabled selected>Select Year</option> -->
                                            <option value="2021">2021</option>
                                            <option value="2022">2022</option>
                                            <option value="2023">2023</option>
                                            <option value="2024">2024</option>
                                            <option value="2025">2025</option>
                                            <option value="2026">2026</option>
                                            <option value="2027">2027</option>
                                          </select>
                                          <label class="floating-label floating-label-special">Select Year</label> 
                                          <i class="ri-calendar-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-2 mb-2">
                                <div class="input mb-0 no-min-width">
                                    <div class="input-item">
                                        <select formControlName="financialYear">
                                            <!-- <option value="" disabled selected>Select Financial Year</option> -->
                                            <option value="2021-2022">2021-2022</option>
                                            <option value="2022-2023">2022-2023</option>
                                            <option value="2023-2024">2023-2024</option>
                                            <option value="2024-2025">2024-2025</option>
                                            <option value="2025-2026">2025-2026</option>
                                            <option value="2026-2027">2026-2027</option>
                                          </select>
                                          <label class="floating-label floating-label-special">Select Financial Year</label> 
                                          <i class="ri-calendar-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-2 mb-2 text-end text-right">
                                <button class="btn" (click)="getTaxRegim()">Click</button>
                            </div>
                        </div>
                    </form>
                    
                    <table class="table border regim-table">
                        <tr>
                            <td class="text-center border-bottom bg-grey" style="font-weight: bold;background-color: #f1f3f6;"></td>
                            <td class="text-center border-bottom bg-grey" style="font-weight: bold;background-color: #f1f3f6;">Old Regim</td>
                            <td class="text-center border-bottom border-right border-left bg-grey" style="font-weight: bold;background-color: #f1f3f6;">New Regim</td>
                        </tr>
                        
                        <tr>
                            <td >Gross Salary</td>
                            <td class="border-right">{{ this.totalPayable }}</td>                         
                            <td class="border-right">{{ this.totalPayable1 }}</td>
                        </tr>
                        <tr>
                           <td><span style="font-weight:bold">Less Excemptions u/s 10</span></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td >Leave Encashment & Gratuity Exemption</td>
							<td class="border-right">{{ this. gratuityPayment }} </td>
							<td class="border-right">{{ this. gratuityPayment1 }}  </td> 
                        </tr>
                        <tr>
                            <td >House Rent Allowance</td>
							<td class="border-right"> {{ this.hra }}</td>
							<td class="border-right"> {{ this.hra1 }}</td>
                        </tr>
                        <tr>
                            <td><span style="font-weight:bold">Gross Salary after Section 10 Exemptions</span></td>
                            <td class="border-right"> {{ this.grossSalaryOutput }}</td>
                            <td class="border-right"> {{ this.grossSalaryOutput1 }}</td>
                        </tr>
                        <tr>
                            <td><span style="font-weight:bold">Deduction U/S 16</span></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td >StandardDeduction</td>
							<td class="border-right"> {{ this.sharedDeduction }}</td>
							<td class="border-right">  {{ this.sharedDeduction1 }}</td> 
                        </tr>
                        <tr>
                            <td >ProfessionalTax</td>
							<td class="border-right"> {{ this.professionalTax }}</td>
							<td class="border-right"> {{ this.professionalTax1 }}</td>
                        </tr>
                        <tr>
                            <td><span style="font-weight:bold">Income chargeable under head 'Salaries'</span></td>
                            <td class="border-right"> {{ this.incomeChargableUnderHeadSalariesOutput }}</td>
                            <td class="border-right"> {{ this.incomeChargableUnderHeadSalariesOutput1 }}</td>
                        </tr>
                        <tr>
                            <td >Income (loss) on House Property(Let Out + Self Occupied)</td>
							<td class="border-right"> {{ this.incomeLossOnHouseProperty }}  </td>
							<td class="border-right"> {{ this.incomeLossOnHouseProperty1 }}  </td> 
                        </tr>
                        <tr>
                            <td >Income from Other Sources </td>
							<td class="border-right"> {{ this.incomeFromHousePropertySection3 }} </td>
							<td class="border-right"> {{ this.incomeFromHousePropertySection31 }} </td> 
                        </tr>
                        <tr>
                            <td><span style="font-weight:bold;background-color: #f1f3f6;">Gross Total Income</span></td>
                            <td class="border-right"> {{ this.exemptionAfterOtherIncomeOutput }} </td>
                            <td class="border-right"> {{ this.exemptionAfterOtherIncomeOutput1 }} </td>
                        </tr>
                        <tr>
                            <td><span style="font-weight:bold">Housing Loan Interest paid </span></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td><span style="font-weight:bold">Deductions Under Section VI-A</span></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td >Investments  ( Sec 80C)</td>
							<td class="border-right"> {{ this.section80C}} </td>
							<td class="border-right"> {{ this.section80C1}} </td> 
                        </tr>
                        <tr>
                            <td >Contribution to NPS Sec 80CCD (1b)</td>
							<td class="border-right"> {{ this.section80CCD}} </td>
							<td class="border-right"> {{ this.section80CCD1}} </td> 
                        </tr>
                        <tr>
                            <td >Employer Contribution to NPS Sec 80CCD (2b)</td>
							<td class="border-right"> {{ this.section80CCD2}} </td>
							<td class="border-right"> {{ this.section80CCD21}}  </td> 
                        </tr>
                        <tr>
                            <td >Medical Insurance Preminum 80D </td>
							<td class="border-right">{{ this.section80DMediclaim}} </td>
							<td class="border-right">{{ this.section80DMediclaim1}}  </td> 
                        </tr>
                        <tr>
                            <td >Medical treatment for handicapped dependents (Sec 80 DD)</td>
							<td class="border-right"> {{ this.section80DD}} </td>
							<td class="border-right"> {{ this.section80DD1}} </td> 
                        </tr>
                        <tr>
                            <td >Medical treatment for specified disease (Sec 80DDB) </td>
							<td class="border-right"> {{ this.section80DDB }} </td>
							<td class="border-right">  {{ this.section80DDB1 }}</td> 
                        </tr>
                        <tr>
                            <td >Interest on Higher Education Loan(Sec 80E) </td>
							<td class="border-right">{{ this.section80E }} </td>
							<td class="border-right">{{ this.section80E1}} </td> 
                        </tr>
                        <tr>
                            <td >Interest on Housing loan (Sec 80EEA) </td>
							<td class="border-right"> {{ this.section80EEA }} </td>
							<td class="border-right"> {{ this.section80EEA1 }}</td> 
                        </tr>
                        <tr>
                            <td >Interest on Electric Vehicle Loan(Sec 80EEB) </td>
							<td class="border-right"> {{ this.section80EEB }}</td>
							<td class="border-right"> {{ this.section80EEB1 }}</td> 
                        </tr>
                        <tr>
                            <td >Donations Eligible for tax deduction </td>
							<td class="border-right"> {{ this.section80GGGAGGC }}</td>
							<td class="border-right"> {{ this.section80GGGAGGC1 }} </td> 
                        </tr>
                        <tr>
                            <td >Deduction in respect of rents paids(Sec 80GG) </td>
							<td class="border-right"> {{ this.section80GG }} </td>
							<td class="border-right"> {{ this.section80GG1 }}</td> 
                        </tr>
                        <tr>
                            <td >Interest income from bank deposits (80TTA/80TTB) </td>
							<td class="border-right">{{ this.section80TTA }}</td>
							<td class="border-right">{{this.section80TTA1 }} </td> 
                        </tr>
                        <tr>
                            <td >Deduction for permanents disability(Sec 80U) </td>
							<td class="border-right">{{ this.section80U }} </td>
							<td class="border-right"> {{this.section80U1 }} </td> 
                        </tr>
                        <tr>
                            <td><span style="font-weight:bold;background-color: #f1f3f6;">Net Taxable Income </span></td>
                            <td class="border-right">{{ this.netTaxableIncomeOutput }}</td>
                            <td class="border-right">{{ this.netTaxableIncomeOutput1 }}</td>
                        </tr>
                        <tr>
                            <td><span style="font-weight:bold;background-color: #f1f3f6;">Total Tax </span></td>
                            <td class="border-right">{{ this.totalTax }}</td>
                            <td class="border-right">{{ this.totalTax1 }}</td>
                        </tr>
                        <tr>
                            <td >Health And Education Cess @4%</td>
							<td class="border-right">{{ this.healthAndEducationCess }}</td>
							<td class="border-right">{{ this.healthAndEducationCess1 }} </td> 
                        </tr>
                        <tr>
                            <td><span style="font-weight:bold;background-color: #f1f3f6;">Total Tax Due</span></td>
                            <td class="border-right">{{ this.totalTaxDue }}</td>
                            <td class="border-right">{{ this.totalTaxDue1 }}</td>
                        </tr>
                    </table>
                </div>
            </section>
        </section>
    </article>
</main>
